import APIClient from '@/shared/http/clients/api'

const resourceName = 'ponto-focal'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetByDocument = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}`, config)

const PontoFocalRepository = {
  GetAll,
  GetByDocument
}

export default PontoFocalRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/pontofocal.js